import React from "react";
import styled from "styled-components";

interface MissionCardProps {
  image: string; // Relative to public folder
  link: string;
  className?: string;
  style?: React.CSSProperties;
}

const CardContainer = styled.div`
  min-width: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: background-color 0.2s ease;
  scroll-snap-align: center;
  cursor: pointer;
  background: #1a1a1a;
  border: 1px solid #333;

  &:hover {
    background-color: #222;
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 0.75rem;
  object-fit: cover;
  transition: transform 0.2s ease;
`;

const MissionCard: React.FC<MissionCardProps> = ({
  image,
  link,
  className,
  style,
}) => {
  return (
    <CardContainer
      className={className}
      style={style}
      onClick={() => window.open(link, "_blank")}
    >
      {/* Use PUBLIC folder image path */}
      <CardImage src={image} alt="Mission Poster" />
    </CardContainer>
  );
};

const CardsContainer = styled.div`
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  padding: 1rem;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const MissionsSection = () => {
  const cards = [
    {
      image: "/posters/1.jpg", // Public folder path
      link: "https://t.me/playops",
    },
    {
      image: "/posters/2.jpg", // Public folder path
      link: "https://youtu.be/TC1wLyibwWs",
    },
    {
      image: "/posters/3.jpg", // Public folder path
      link: "https://youtu.be/tlRPjo3NWyY",
    },
  ];

  return (
    <CardsContainer>
      {cards.map((card, index) => (
        <MissionCard
          key={index}
          image={card.image}
          link={card.link}
          style={{ animationDelay: `${index * 100}ms` }}
        />
      ))}
    </CardsContainer>
  );
};

export default MissionsSection;
